module.exports = __webpack_public_path__ + "static/media/271045.94880912.png";